<template>
  <section class="team section" id="team">
    <div class="wrapper">
      <h2 class="title">Equipe</h2>
      <div class="team-members">
        <div class="row center-xs middle-xs">
          <div class="col-md-12 col-sm-12 col-xs-12 team-member"
            :key="index"
            v-for="(advogado, index) in api">
            <div class="avatar"><img :src="advogado.foto" alt=""></div>
            <div class="info">
              <h5 class="title name">{{advogado.nome}}</h5>
              <span class="role">{{advogado.cargo}}</span>
              <p class="text" v-html="advogado.texto"></p>
              <a :href="('mailto:' + advogado.e_mail)" class="mail">{{advogado.e_mail}}</a>
              <ul class="social">
                <li>
                  <a :href="advogado.lattes">
                    <i class="lattes"></i>
                  </a>
                </li>
                <li>
                  <a :href="advogado.linkedin">
                    <i class="linkedin"></i>
                  </a>
                </li>
                <li>
                  <a :href="advogado.v_card">
                    <i class="v-card"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Time',
  props: ['api'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  #team
    padding 100px 0
    background url('../assets/team-bg.jpg') #F9F9F9 no-repeat top
    h2
      text-align center
    .team-member
      box-shadow 0 0 15px rgba(0,0,0, .1)
      margin-bottom 30px
      border-radius 10px
      padding 0
      background white
      display flex
      max-height 273px
      flex-direction row
      .role
        font-size 14px
        color #7C8A8F
        margin 0 0 10px
      p
        font-size 14px
        line-height 1.5
      h5
        margin 0
      .avatar
        max-width 200px
        display inline-block
        flex 1
      .info
        flex 1
        padding 20px 30px
        display inline-block
        text-align left
        .mail
          text-decoration none
          color black
          font-size 14px
          font-weight bold
        ul
          margin-bottom 0
          li
            display inline-block
            margin-right 10px
            position relative
            width 35px
            height 35px
            a
              border-radius 50%
              box-shadow 0 0 15px rgba(0,0,0, .1)
              width 35px
              height 35px
              display block
              position relative
              text-align center
              vertical-align center
              transition .3s all ease
              &:hover
                box-shadow 0 0 15px rgba(0,0,0, .3)
            i
              display block
              position absolute
              left 50%
              top 50%
              transform translate(-50%,-50%)
              &.lattes
                width 14px
                height 14px
                background url('../assets/icon-lates.png') no-repeat center
                background-size contain
              &.v-card
                width 14px
                height 14px
                position relative
                background url('../assets/icon-v-card.png') no-repeat center
                background-size contain
              &.linkedin
                width 15px
                height 14px
                position relative
                background url('../assets/icon-linkedin.png') no-repeat center
                background-size contain
    @media (max-width 1250px)
      .team-member
        max-height inherit
        padding 20px 0
    @media (max-width 600px)
      .team-member
        display block
      .avatar, .info
        display block
</style>



// WEBPACK FOOTER //
// src/components/TeamSection.vue